import { useQuery } from "@tanstack/react-query";
import { keys } from "../../core/queries/queries-keys";
import {
  HistoricalData,
  Timeframe,
  TokenWithBalance,
  TokenWithTokenData,
} from "../../core/types/tokens";
import {
  fetchHistoricalData,
  fetchTokensData,
} from "../../services/external/tokenDataService";

// Coingecko has a limit for some queries for multiple tokens, not sure what it is, but let's use 100 for now

export const useHistoricalData = (
  coingeckoId: string | undefined,
  timeFrame: Timeframe
) => {
  return useQuery<HistoricalData | null, Error>(
    keys().historicalData(coingeckoId, timeFrame),
    () => fetchHistoricalData(coingeckoId!, timeFrame),
    {
      staleTime: 5 * 60 * 1000,
      enabled: !!coingeckoId,
    }
  );
};

export const useTokensData = (tokens: TokenWithBalance[] | undefined) => {
  return useQuery<TokenWithTokenData[], Error>(
    keys().tokensData(tokens),
    () => fetchTokensData(tokens!),
    {
      staleTime: 60 * 1000,
      enabled: !!tokens && tokens.length > 0,
    }
  );
};

export const useTokenData = (token: TokenWithBalance | undefined) => {
  return useQuery<TokenWithBalance, Error>(
    keys().tokenData(token),
    () => fetchTokensData([token!]).then((tokens) => tokens[0]),
    {
      staleTime: 60 * 1000,
      enabled: !!token,
    }
  );
};
